<template>
    <div v-if="show.showPage">
        <div class="smartnlp-mask" ></div>
        <div class="smartnlp-evaluation" :class="chatDataCenter.set.windowSize=='1'?'smartnlp-evaluation':'smartnlp-evaluation1'">
            <div class="smartnlp-dialog-title">请对本次服务进行评价<a><img src="../../../static/images/m-c.png" style="width: 10px;height: 10px;" @click="closePageButton"></a></div>
            <div class="evaluation-height">
              <div class="smartnlp-evaluation-first">
                <div class="smartnlp-evaluation-content">
                  <div class="smartnlp-evaluation-bq" v-if="evaluateDto!=null" v-for="(item,index) in evaluateDto.itemList ">
                    <div>
                      <img src="../../../static/images/my-c.png" v-if="index==0&&evaluation.chooseIndex!=0" @click="evaluation.chooseIndex=0">
                      <img src="../../../static/images/my-a.png" v-if="index==0&&evaluation.chooseIndex==0" @click="evaluation.chooseIndex=0">
                      <img src="../../../static/images/yb-c.png" v-if="index==1&&evaluation.chooseIndex!=1" @click="evaluation.chooseIndex=1">
                      <img src="../../../static/images/yb-a.png" v-if="index==1&&evaluation.chooseIndex==1" @click="evaluation.chooseIndex=1">
                      <img src="../../../static/images/bmy-c.png" v-if="index==2&&evaluation.chooseIndex!=2" @click="evaluation.chooseIndex=2">
                      <img src="../../../static/images/bmy-a.png" v-if="index==2&&evaluation.chooseIndex==2" @click="evaluation.chooseIndex=2">
                    </div>
                    <div class="smartnlp-evaluation-title " :class="{'evaluation-active':index==evaluation.chooseIndex}">{{item.tagItem}}</div>
                  </div>
                </div>
              </div>
              <div class="smartnlp-evaluation-second">
                <div class="smartnlp-evaluation-second-ul">
                  <ul class="clearfix"  v-if="evaluateDto!=null">
                    <li v-for="(item,index) in evaluateDto.itemList[evaluation.chooseIndex].tagList">
                      <a :class="{'tag-active':evaluation.tags.indexOf(item.tagName)>-1}" @click="updateTag(item.tagName)">{{item.tagName}}</a>
                    </li>
                  </ul>
                </div>
                <div class="smartnlp-evaluation-second-textarea" v-if="show.showRemark">
                  <textarea v-model.trim="evaluation.remark" :maxlength="200" placeholder="请输入评价内容"></textarea>
                </div>
                <div class="smartnlp-evaluation-submit" >
                  <button type="button" :style="'background:'+ chatDataCenter.linkInfo.windowColor" @click="saveEvaluation">提交</button>
                </div>
                <div class="smartnlp-evaluation-cancel">
                  <button type="button" @click="evaluationNo" v-show="chatDataCenter.evaluation.closeType=='1'">暂不评论</button>
                </div>
              </div>
            </div>

        </div>
    </div>
</template>

<script>

    import chatDataCenter from "../../jsSdk/chatDataCenter";
    export default {
        name: "evaluation",
        data() {
            return {
                chatDataCenter,
                evaluateDto:null,
                show:{
                    showPage:false,
                    showRemark:false
                },
                evaluation:{
                    chooseIndex:0,
                    tags:[],
                    remark:"",
                },
            }
        },
        computed:{
            evaluationShow() {
                return chatDataCenter.evaluation.show
            },
            chooseIndex() {
                return this.evaluation.chooseIndex
            }
        },
        watch: {
            evaluationShow:{
                handler(curVal,oldVal){
                    if(curVal!=undefined&&curVal){
                        this._init_();
                    }
                },
                deep: true,
                immediate:true
            },
            chooseIndex:{
                handler(curVal,oldVal){
                    if(curVal!=oldVal){
                        this.evaluation.tags=[]
                    }
                },
                deep: true,
                immediate:true
            },
        },
        methods:{
            /**
             * 选择评价标签
             * */
            updateTag:function (name) {
                var index=this.evaluation.tags.indexOf(name);
                if(index>-1){
                    this.evaluation.tags.splice(index, 1);
                }else {
                    this.evaluation.tags.push(name)
                }
            },
            /**
             * 【按钮】右上角关闭
             * */
            closePageButton:function () {
                var _this = this;
                chatDataCenter.evaluation.show=false
                _this.show.showRemark=false
                _this.show.showPage=false
            },
            //2客服主动3客户超时回复4客服超时回复
            closePage:function () {
                var _this = this;
                chatDataCenter.evaluation.show=false
                _this.show.showRemark=false
                _this.show.showPage=false
                //1客户主动关闭并且从frame进入,关闭页面，其他不关闭页面
                if (chatDataCenter.set.isIFrame&&chatDataCenter.chatRoom.sessionId==null&&chatDataCenter.evaluation.closeType=='1'){
                    parent.postMessage('deleteIframe', '*');
                    chatDataCenter.set.windowFlag='2'
                }
            },
            /**
             * 【按钮】暂不评论（关闭会话，并删除iFrame）
             * */
            evaluationNo:function () {
                var _this = this;
                if(chatDataCenter.evaluation.closeType=='1'){//1客户主动关闭,且无需评论
                    chatDataCenter.closeSessionByCustomer(function (data) {
                        if(data.code==0 ){
                            chatDataCenter.closeSession();
                            _this.closePage();
                        }else{
                            _this.$messageBox.Success({message:data.msg,duration:3000});
                        }
                    })
                }
            },
            /**
             * 初期化页面
             * */
            _init_:function () {
                var _this = this;
                _this.evaluation.chooseIndex=0
                _this.evaluation.remark=''
                _this.evaluation.tags=[]
                if(chatDataCenter.evaluation.customerEvaluate === 0){// 会话被关闭的时候 若没有评价,则主动弹出评价窗口
                    chatDataCenter.getEvaluateByCompanyId(_this,function (response) {
                        if (response.code==0) {
                            _this.evaluateDto = response.data;
                            if ( response.data!==null){
                                if(chatDataCenter.evaluation.closeType=='5'||chatDataCenter.evaluation.closeType=='6'){
                                    // 顾客主动评价、客服邀请评价
                                    _this.show.showPage=true
                                }else {
                                    // 关闭会话类型：1客户主动关闭2客服主动3客户超时回复4客服超时回复
                                    if(_this.evaluateDto.closeType!=''&&_this.evaluateDto.closeType!=null&&response.data.closeType.indexOf(chatDataCenter.evaluation.closeType)>-1){
                                        _this.show.showPage=true
                                    }else {
                                        _this.show.showPage=false
                                    }
                                }
                                if(_this.show.showPage){
                                    //显示评价页面
                                    if (response.data.openEvaluateFlag==1){
                                        console.log("显示输入评价备注的文本框");
                                        _this.show.showRemark=true
                                    }else {
                                        _this.show.showRemark=false
                                    }
                                }else {
                                    // 无需弹出评价页面（关闭会话类型：1客户主动关闭2客服主动3客户超时回复4客服超时回复）
                                    _this.closePageDirect();
                                }
                            }else {
                                console.log("没有评价设置");
                            }
                        }else{
                            _this.$messageBox.Error({message:response.msg,duration:3000});
                        }
                    })
                }else {
                    //无需弹出评价页面（关闭会话类型：1客户主动关闭2客服主动3客户超时回复4客服超时回复5:邀请评价6：顾客主动评价）
                    _this.closePageDirect();
                }
            },
            /**
             * 判断之后，无需弹出评价页面，根据具体类型显示对应内容
             *  1：客户主动关闭 （弹出确认是否关闭会话）
             *  2：客服主动3：客户超时回复4：客服超时回复 （直接关闭画面，并删除iFrame）
             *  5: 客服邀请评价（不做操作）
             *  6：顾客主动评价（弹出会话已评价）
             * */
            closePageDirect:function () {
                var _this = this;
                _this.evaluation.show=false
                if(chatDataCenter.evaluation.closeType=='1'){
                    console.log("客户主动关闭,且无需评论");
                    _this.$messageBox.Confirm({ title:"确认提示",message:'确认是否关闭会话?',
                        onClose:function () { _this.closePage(); },
                        onCancel:function () { _this.closePage(); },
                        onConfirm:function () {
                            chatDataCenter.closeSessionByCustomer(function (data) {
                                if(data.code==0 ){
                                    chatDataCenter.closeSession();
                                    _this.closePage();
                                }else{
                                    _this.$messageBox.Success({message:data.msg,duration:3000});
                                }
                            })
                        }
                    });
                } else  if(chatDataCenter.evaluation.closeType=='6'){
                    //6：顾客主动评价
                    _this.$messageBox.Error({message:"会话已评价",duration:3000});
                } else  if(chatDataCenter.evaluation.closeType!='5'){
                    //2客服主动3客户超时回复4客服超时回复
                    _this.closePage();
                }
            },

            /**
             * 【按钮】保存评论内容
             * */
            saveEvaluation:function () {
                var _this = this;
                if(chatDataCenter.evaluation.closeType=='1'){
                    chatDataCenter.closeSessionByCustomer(function (data) {
                        if(data.code==0 ){
                            chatDataCenter.closeSession();
                            _this.sendEvaluation();
                        }else{
                            _this.$messageBox.Success({message:data.msg,duration:3000});
                        }
                    })
                }else {
                    _this.sendEvaluation();
                }
            },
            /**
             * 保存评论内容
             * */
            sendEvaluation:function () {
                var _this = this;
                var save={
                    evaluate:(_this.evaluation.chooseIndex+1),
                    tags:(_this.evaluation.tags.join(";")),
                    remark:(_this.evaluation.remark),
                    sessionId:chatDataCenter.evaluation.sessionId
                }
                _this.$axiosService.post('chatCustomer/customerEvaluate', save, response => {
                    if (response.code==0) {
                        chatDataCenter.evaluation.customerEvaluate=save.evaluate
                        if (chatDataCenter.chatRoom.sessionId!=null&&chatDataCenter.evaluation.sessionId==chatDataCenter.chatRoom.sessionId){
                            chatDataCenter.chatRoom.customerEvaluate=save.evaluate
                        }
                        _this.closePage();
                        _this.$messageBox.Success({message:"已发送评价",duration:3000});
                    }else{
                        _this.$messageBox.Error({message:response.msg,duration:3000});
                    }
                });
            },
        },
    }
</script>

<style scoped>
    @import "../../../static/css/main.css";
</style>
